// extracted by mini-css-extract-plugin
module.exports = {"empty_main":"layout_empty_main__mKHQC","main":"layout_main__5hZLh"};